import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ApiGatewayService } from 'src/app/shared/services/api.gateway.service';
import { SafeDropLocation, SafeDropLocationImpl } from "../../standalone/home/model/safedroplocation";

@Injectable({
  providedIn: 'root'
})
export class SafeDropLocationService {

  private safeDropLocation: SafeDropLocation;

  constructor(private _apiGateway: ApiGatewayService, public translateService: TranslateService) {
    this.safeDropLocation = { desc: '', cd: '', descEn: '', descFr: '' }
  }

  getSafeDropLocation(code?: string): Observable<SafeDropLocation> {
    // Make a GET request to the API gateway to retrieve safe drop location data
    return this._apiGateway.get("/rs/location", {
      params: code // Optional parameter for filtering the location based on the code
    }).pipe(
      map(
        resp => {
          // Use the response to create an instance of SafeDropLocation using a factory method
          const sdl = SafeDropLocationImpl.locationFactory(resp, this.translateService.currentLang);

          // Store the created SafeDropLocation instance for future reference
          this.safeDropLocation = sdl;

          // Return the newly created SafeDropLocation instance
          return sdl;
        }
      )
    );
  }

  onLangChange(currentLang: string): Observable<SafeDropLocation> {
    // Create a shallow copy of the current safe drop location to avoid mutating the original object
    const clone = { ...this.safeDropLocation };

    // Update the description based on the current language; use French if 'fr', otherwise use English
    clone.desc = currentLang === 'fr' ? this.safeDropLocation.descFr : this.safeDropLocation.descEn;

    // Update the class property with the modified clone
    this.safeDropLocation = clone;

    // Return an observable containing the updated safe drop location
    return of(clone);
  }
}
